/**
 * Checks whether given parameter is a function
 *
 * @param fn parameter evaluated as function
 */
export function isFunction(fn: any): boolean {
  return typeof fn === "function";
}
